/** Die Seite des Designers und des Operators, solange der Server keine gültige Lizenz hat. */
export default {
	noLicense: {
		title: "Keine gültige Lizenz",
		note: "Dieser Server hat keine gültige Lizenz, deshalb sind Designer und Operator geschlossen. Bitten Sie eine Serveradministratorin oder einen Serveradministrator, einen Lizenzschlüssel einzugeben.",
		noteAdmin:
			"Dieser Server hat keine gültige Lizenz, deshalb sind Designer und Operator geschlossen. Geben Sie im Kontrollzentrum einen Lizenzschlüssel ein; es bleibt geöffnet.",
		openControlCenter: "Lizenzeinstellungen öffnen",
		tryAgain: "Erneut versuchen",
	},
};
